export function getBaseUrl() {
  const configured = (process.env.REACT_APP_API_BASE_URL || '').trim();
  return configured ? configured.replace(/\/$/, '') : '';
}

export function buildApiUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getBaseUrl()}/api${normalizedPath}`;
}

/** 免费版 ngrok 对浏览器请求会返回提示页；带上此头可让同源 API 请求拿到 JSON 而非 HTML 提示页（见 ngrok 文档） */
function ngrokBrowserWarningBypassHeaders() {
  if (typeof window === 'undefined') return {};
  if (!/ngrok/i.test(window.location.hostname)) return {};
  return { 'ngrok-skip-browser-warning': 'true' };
}

export async function requestApi(path, {
  method = 'GET',
  data,
  token,
  responseType = 'json',
  checkOk = true
} = {}) {
  const headers = {
    ...ngrokBrowserWarningBypassHeaders(),
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };

  if (data !== undefined) {
    headers['Content-Type'] = 'application/json';
  }

  const response = await fetch(buildApiUrl(path), {
    method,
    headers,
    body: data !== undefined ? JSON.stringify(data) : undefined
  });

  if (checkOk && !response.ok) {
    const errorText = await response.text();
    const error = new Error(`请求失败 (${response.status})`);
    error.status = response.status;
    error.body = errorText;
    throw error;
  }

  if (responseType === 'raw') return response;
  if (responseType === 'blob') return response.blob();
  if (responseType === 'text') return response.text();
  return response.json();
}
